import { LogEntryData, LogEntryResponse } from 'src/common-services/types/logging-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class LoggingClient extends BaseClient {
  logData(data: LogEntryData): void {
    // eslint-disable-next-line no-console
    this.call<LogEntryResponse>('/log/data', 'POST', { data: data }).catch((e) => console.error(e))
  }
}
